import { SecureTenantStore } from '@infra/persistence/SecureTenantStore';

/** Migre les clés localStorage legacy vers SQLite chiffré au premier démarrage Electron. */
export async function migrateModuleDataFromLocalStorage(tenantId: string): Promise<number> {
  const migrations: Array<{ namespace: string; legacyKey: string }> = [
    { namespace: 'viesociale.rapport', legacyKey: `nexxus.viesociale.${tenantId}.rapport` },
    { namespace: 'viesociale.ri', legacyKey: `nexxus.viesociale.${tenantId}.ri` },
    { namespace: 'coffrefort', legacyKey: `nexxus.coffrefort.${tenantId}` },
    { namespace: 'rgpd.dpo', legacyKey: `nexxus.rgpd.${tenantId}.dpo` },
    { namespace: 'rgpd.traitements', legacyKey: `nexxus.rgpd.${tenantId}.traitements` },
    { namespace: 'conformite.profil', legacyKey: `nexxus.conformite.${tenantId}.profil` },
    { namespace: 'conformite.patente', legacyKey: `nexxus.conformite.${tenantId}.patente` },
  ];

  let count = 0;
  for (const m of migrations) {
    if (await SecureTenantStore.migrateLegacyKey(tenantId, m.namespace, m.legacyKey)) {
      count += 1;
    }
  }
  return count;
}
